import React, { Fragment } from 'react';
import { Image, Source } from '@unpic/react';
import { useGetExperiment } from '@printdeal/feature-management/react';
import { Hotspot, InteractiveHotspot } from './InteractiveHotspot';
import useMediaQuery from '../../hooks/useMediaQuery';
import { InteractiveImageHotspot } from './InteractiveImageHotspot';

export type InteractiveImage = {
  interactiveImageId: string;
  bannerURL: string;
  bannerWidth: number;
  bannerHeight: number;
  hotspots?: Hotspot[];
};

interface Props {
  image: InteractiveImage;
  imageMobile: InteractiveImage;
}

export const InteractiveBanner = ({ image, imageMobile }: Props) => {
  const mediaQuery = '(min-width: 992px)';
  const isDesktop = useMediaQuery(mediaQuery);
  const getExperiment = useGetExperiment();
  const isExp1489 = getExperiment('ninjas_exp1489_add_clickable_products_on_pictures', () => {}).experiment?.variation === 'variant';
  const isExp764 = getExperiment('exp764_clickable_product_tags_in_gallery', () => {})?.experiment?.variation === 'variant';

  const imageURL = isDesktop ? image.bannerURL : imageMobile.bannerURL;
  const hotspots = isDesktop ? image.hotspots : imageMobile.hotspots;

  return (
    <div className="pd-relative pd-h-auto pd-w-full">
      <picture>
        {['avif', 'webp', null].map((format) => (
          <Fragment key={format || 'default'}>
            <Source
              src={`${image.bannerURL}?fm=${format || ''}`}
              media={mediaQuery}
              width={image.bannerWidth}
              height={image.bannerHeight}
              type={format && `image/${format}`}
              breakpoints={[320, 640, 950]}
              layout="constrained"
            />
          </Fragment>
        ))}
        <Image
          src={imageURL}
          layout="fullWidth"
          alt=""
          priority
          unstyled
        />
      </picture>
      <div className="pd-absolute pd-left-0 pd-top-0 pd-size-full">
        {isExp1489 && hotspots?.map((hotspot) => (
          <InteractiveHotspot
            key={hotspot.id}
            hotspot={hotspot}
          />
        ))}
        {isExp764 && hotspots?.map((hotspot) => (
          <InteractiveImageHotspot
            key={hotspot.id}
            hotspot={hotspot}
          />
        ))}
      </div>
    </div>
  );
};
